<template>
    <a class="btn btn-small reset-btn" :class="customClass" href="#" @click="EBusEmit(clickEvent)">
        <svg width="16" height="16" viewBox="0 0 339 414" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;transform: scale(-1, 1);">
            <g transform="matrix(1,0,0,1,-817.641,-1679.31)">
                <path d="M986.886,1679.31L1104.78,1770.6L986.886,1861.89L986.886,1787.24C911.805,1787.24 850.939,1848.1 850.939,1923.18C850.939,1998.21 911.855,2059.13 986.886,2059.13C1061.97,2059.13 1122.83,1998.26 1122.83,1923.18L1156.13,1923.18C1156.13,2016.65 1080.36,2092.43 986.886,2092.43C893.477,2092.43 817.641,2016.59 817.641,1923.18C817.641,1829.71 893.415,1753.94 986.886,1753.94L986.886,1679.31Z" style="fill:white;"/>
            </g>
        </svg>
    </a>
</template>

<script>
import { EventBus } from '../event-bus.js';

export default {
  name: 'ResetBtn',
  data() {
    return {
    }
  },
  methods: {
      EBusEmit(command){
          EventBus.$emit(command);
      }
  },
  props: {
      'clickEvent': String,
      'customClass': String,
  }

}
</script>

<style scoped>

</style>